// src/components/EducationSection.jsx
import React from 'react';
import './EducationSection.css';

import anaokuluImg  from '../assets/sokullu.jpg';
import ilkokulImg   from '../assets/okul.jpg';
import liseImg      from '../assets/vipkurs.jpg';
import skillsImg    from '../assets/sanat.jpg';  // yeni görselinizi bu dosya adıyla ekleyin

const options = [
  {
    id: 1,
    title: 'Anaokulu',
    desc: 'Oyun temelli, sevgi dolu başlangıç.',
    img: anaokuluImg,
    path: '/anaokulu'
  },
  {
    id: 2,
    title: 'İlk ve Ortaokul',
    desc: 'Temel akademik ve sosyal beceriler. Proje tabanlı öğrenme ve deney.',
    img: ilkokulImg,
    path: '/ilkokul-ortaokul'
  },
  {
    id: 3,
    title: 'LGS, YKS Hazırlık ve VIP Kurslar',
    desc: 'Akademik müfredat. VIP deneyim. Deneme sınavları ve etüt programı.',
    img: liseImg,
    path: '/dikmen-kurs-lise-yks-vip'
  },

];

export default function EducationSection() {
  return (
    <section id="education-section" className="education-section">
      <h2>Eğitimlerimiz</h2>
      <div className="education-grid">
        {options.map(o => (
          <div key={o.id} className="education-item">
            <img src={o.img} alt={o.title} />
            <div className="caption">
              <h3>{o.title}</h3>
              <p>{o.desc}</p>
              <a href={o.path} className="btn-incele">
                İncele &gt;
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
